export const chartColumns = [
  {
    field: 'projectCode',
    title: '项目编号',
    width: '120',
  },
  {
    field: 'projectName',
    title: '项目名称',
    width: '120',
  },
  {
    field: 'contractCode', ///
    title: '合同编号',
    width: '150',
  },
  {
    field: 'contractName',
    title: '合同名称',
    width: '140',
  },
  {
    field: 'contractType',
    title: '合同类型',
    width: '140',
  },
  {
    field: 'contractSignDate',
    title: '签订日期',
    width: '140',
  },
  {
    field: 'relationship',
    title: '关联标识',
    width: '140',
  },
];
